/**
 * 2022-2024 Stadt Wolfsburg
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import * as XLSX from "xlsx";

const WobIdentifyUtils = {
    convertToXlsx(json) {
        const workbook = XLSX.utils.book_new();
        Object.entries(json).forEach(([layerName, features]) => {
            const data = [];
            features.forEach((feature) => {
                const currentData = {};
                Object.entries(feature.properties || {}).forEach(([attrib, value]) => {
                    if (attrib !== "htmlContent" && attrib !== "htmlContentInline") {
                        currentData[String(attrib)] = String(value);
                    }
                });
                if (currentData) {
                    data.push(currentData);
                }
            });
            if (data) {
                let worksheetName = String(layerName);
                if (worksheetName.length > 31) {
                    worksheetName = worksheetName.substring(0, 31 - 3) + "...";
                }
                const worksheet = XLSX.utils.json_to_sheet(data);
                XLSX.utils.book_append_sheet(workbook, worksheet, worksheetName);
            }
        });
        const fileName = "results.xlsx";
        const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});
        const exportData = new Blob([excelBuffer], {type: fileType});

        return {
            data: exportData,
            fileName: fileName,
            fileType: fileType
        };
    }
};

export default WobIdentifyUtils;
